import styled from "styled-components";
import {TextField} from "@material-ui/core";

export const SearchTextFieldStyled = styled(TextField)`
   width: 400px;
   fieldset {
    border-radius: 50px;
  }
`;